import * as React from 'react';
import { useRef } from 'react';
import { Shipment } from '../../../IRouteAudit';
import GridConfig from './GridConfig';
import CommonGrid from '../../../../../../common/GridWithHeader/CommonGrid';

interface ShipmentsGridProps {
  data: Shipment[] | null;
  onToggleGridMaximize: (isMaximized: boolean) => void;
  visible: boolean;
  userData: any;
}

const ShipmentsGrid = ({ data, onToggleGridMaximize, visible, userData }: ShipmentsGridProps) => {
  const gridConfig = useRef(new GridConfig({ userConfig: userData.userProfile?.columnPref }));

  return (
    <CommonGrid
      title="Pros"
      exportFileName="shipments"
      data={data}
      config={gridConfig.current.config}
      onToggleGridMaximize={onToggleGridMaximize}
      isVisible={visible}
    />
  );
};

export default ShipmentsGrid;
